module.exports = __webpack_public_path__ + "img/stand_luoluo_1.e7a8648c.jpg";